import { graphql, useStaticQuery } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const usePrismicFooterContactLinks = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    fragment FooterContactLinksFields on PrismicFooterDataType {
      address {
        html
      }
      contact_headline
      contact_links {
        link_text
        link_to {
          url
        }
      }
      socials_headline
      social_links {
        link_text
        link_to {
          url
        }
      }
    }

    query FooterContactLinksQuery {
      en: prismicFooter(lang: { eq: "en-us" }) {
        data {
          ...FooterContactLinksFields
        }
      }

      de: prismicFooter(lang: { eq: "de-de" }) {
        data {
          ...FooterContactLinksFields
        }
      }
    }
  `);

  return data[locale];
};
